module.exports = __webpack_public_path__ + "img/filled-riceball.94c38dac.svg";